import UpdateTripOrder from "../../../../components/@documents/trip_orders/UpdateTripOrder";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function TripOrderUpdatePage() {

    return (
        <UpdateTripOrder 
            routeType={routeTypes.workstation}
        />
    )
}